import { render } from "./btn-move-border.vue?vue&type=template&id=1795608e&scoped=true"
import script from "./btn-move-border.vue?vue&type=script&lang=js"
export * from "./btn-move-border.vue?vue&type=script&lang=js"

import "./btn-move-border.vue?vue&type=style&index=0&id=1795608e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-1795608e"

export default script